// extracted by mini-css-extract-plugin
export default {"Container":"Collapse_Container__Phyll","fleche":"Collapse_fleche__75zv+","Titre":"Collapse_Titre__usR73","content":"Collapse_content__8FBwF"};